import { useNavigate } from "@tanstack/react-router";
import { useAtomValue } from "jotai";

import { Button, PageHeader, TabBar } from "@go-novus/ui";

import {
  knowledgeOverviewAtom,
  knowledgeQuestionsAtom,
  readKnowledgeFailureMessage,
} from "#/features/knowledge";
import * as m from "#/paraglide/messages";

import type { KnowledgeTab } from "../lib/knowledge-tab";
import { ProductSection } from "./product-section";
import { QuestionsSection } from "./questions-section";

const TAB_ORDER: KnowledgeTab[] = ["products", "questions"];
const TAB_LABEL = {
  products: m.knowledge_tab_products,
  questions: m.knowledge_tab_questions,
};

export interface KnowledgePageProps {
  onSectionChange: (section: KnowledgeTab) => void;
  section: KnowledgeTab;
}

/** 商品读 Shopify，问答读 MyQA Online；标签仍由 URL 保存。 */
export function KnowledgePage({
  onSectionChange,
  section,
}: KnowledgePageProps) {
  const navigate = useNavigate();
  const overview = useAtomValue(knowledgeOverviewAtom);
  const questions = useAtomValue(knowledgeQuestionsAtom);
  return (
    <div className="flex h-full min-h-0 flex-col gap-4.5">
      <div className="flex flex-col gap-4.5">
        <PageHeader
          actions={
            <Button
              onClick={() => {
                void navigate({ to: "/playground" });
              }}
              size="sm"
              variant="primary"
            >
              {m.knowledge_test_in_playground()}
            </Button>
          }
          meta={
            section === "products"
              ? readKnowledgeFailureMessage(overview.error)
              : null
          }
          title={m.knowledge_page_title()}
        />
        <TabBar
          label={m.knowledge_tabs_label()}
          onChange={(value) => {
            const next = TAB_ORDER.find((item) => item === value);
            if (next !== undefined) onSectionChange(next);
          }}
          tabs={TAB_ORDER.map((item) => ({
            count:
              item === "products"
                ? overview.data?.sections.products.count
                : questions.data?.pages[0]?.total,
            label: TAB_LABEL[item](),
            value: item,
          }))}
          value={section}
        />
      </div>
      {section === "products" ? <ProductSection /> : <QuestionsSection />}
    </div>
  );
}
